import React, { useState, useEffect, useCallback } from 'react';
import './Toast.css';

let toastId = 0;
let addToastFn = null;

// 全局 toast 方法
export const toast = {
  show: (message, type = 'info', duration = 3000) => {
    if (addToastFn) {
      addToastFn({ id: ++toastId, message, type, duration });
    }
  },
  success: (message, duration) => toast.show(message, 'success', duration),
  error: (message, duration) => toast.show(message, 'error', duration),
  warning: (message, duration) => toast.show(message, 'warning', duration),
  info: (message, duration) => toast.show(message, 'info', duration),
};

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((newToast) => {
    setToasts(prev => [...prev, newToast]);

    // 自动移除
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== newToast.id));
    }, newToast.duration);
  }, []);

  useEffect(() => {
    addToastFn = addToast;
    return () => {
      addToastFn = null;
    };
  }, [addToast]);

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`} onClick={() => removeToast(t.id)}>
          <span className="toast-message">{t.message}</span>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
